import {
  AddBroadcastLayout,
  Form,
  SubmitButton,
} from "./AddBroadcastGroup.style";
import { DrawerDivider } from "../layout/RightDrawer.style";
import {
  IBroadcastGroupData,
  IBroadcastInfo,
} from "@home-health-notify/domain";
import { useTranslation } from "hhn-commons";
import { NameField } from "../common/InputFields/NameField";
import { AboutField } from "../common/InputFields/AboutField";

type AddBroadcastGroupInfoProps = {
  addBroadcastGroupInfo: (data: IBroadcastGroupData) => void;
  onSetBroadcastGroupData: (data: IBroadcastGroupData) => void;
  broadcastGroupData: IBroadcastGroupData;
  broadcastInfo?: IBroadcastInfo;
};
export const AddBroadcastGroupInfo = ({
  addBroadcastGroupInfo,
  onSetBroadcastGroupData,
  broadcastGroupData,
  broadcastInfo,
}: AddBroadcastGroupInfoProps) => {
  const { t } = useTranslation();
  const tNsBroadcast = (key: string) => t(key, { ns: "broadcastGroup" });

  const onFormDataChange = (key: string, value: string) => {
    onSetBroadcastGroupData((prev: IBroadcastGroupData) => {
      return { ...prev, [key]: value };
    });
  };

  const onNextClick = () => {
    addBroadcastGroupInfo(broadcastGroupData);
  };

  const { name, about } = broadcastGroupData;

  return (
    <AddBroadcastLayout>
      <Form>
        <NameField
          value={name ?? ""}
          label={tNsBroadcast("nameLabel")}
          onChange={onFormDataChange}
        />
        <AboutField
          value={about ?? ""}
          label={tNsBroadcast("aboutLabel")}
          onChange={onFormDataChange}
        />
      </Form>
      <DrawerDivider />
      <SubmitButton
        variant="contained"
        onClick={() => onNextClick()}
        data-testid="next button"
      >
        {broadcastInfo ? t("buttonLabels.update") : t("buttonLabels.next")}
      </SubmitButton>
    </AddBroadcastLayout>
  );
};
